import React from "react";
import styled, { css } from "styled-components";
import { ArrowNext } from "assets/images/MenuArrow";
import { useTranslation } from "react-i18next";
import logoutIcon from "../../assets/images/icon_logout.svg";

export interface OmronSidebarProps {
  profile?: boolean;
  download?: boolean;
  software?: boolean;
  activation?: boolean;
  trial?: boolean;
  onLogout?: () => Promise<boolean>;
}

const OmronSidebar: React.FC<OmronSidebarProps> = (
  props: OmronSidebarProps
) => {
  const { profile, download, software, activation, trial, onLogout } = props;
  const { t } = useTranslation();

  return (
    <Sidebar>
      <SidebarInner>
        <ul>
          <li>
            <SidebarLink isActive={download || false} href="/download">
              {t("common.label.menuDownload")}
              <ArrowNext />
            </SidebarLink>
          </li>
          <li>
            <SidebarLink isActive={trial || false} href="/trial">
              {t("common.label.menuTrial")}
              <ArrowNext />
            </SidebarLink>
          </li>
          <li>
            <SidebarLink isActive={software || false} href="/software">
              {t("common.label.menuSoftware")}
              <ArrowNext />
            </SidebarLink>
          </li>
          <li>
            <SidebarLink isActive={activation || false} href="/activation">
              {t("common.label.menuActivate")}
              <ArrowNext />
            </SidebarLink>
          </li>
          <li>
            <SidebarLink isActive={profile || false} href="/profile">
              {t("common.label.menuProfile")}
              <ArrowNext />
            </SidebarLink>
          </li>
        </ul>
        <SignoutUl>
          <li>
            <HelpLink
              href={t("common.link.linkHelp")}
              target="_blank"
              rel="noreferrer"
            >
              {t("common.label.menuHelp")}
            </HelpLink>
          </li>
          <SignoutLi>
            <SignoutLink onClick={onLogout}>
              {t("common.label.logout")}
              <IconImg src={logoutIcon} alt="Logout" />
            </SignoutLink>
          </SignoutLi>
        </SignoutUl>
      </SidebarInner>
    </Sidebar>
  );
};

OmronSidebar.defaultProps = {
  profile: false,
  download: false,
  software: false,
  activation: false,
  trial: false,
  onLogout: undefined,
};

export default OmronSidebar;

// style

const Sidebar = styled.aside`
  grid-area: side;
  position: fixed;
  top: 117px;
  width: 20rem;
  height: calc(100% - 117px);
  border-right: 0.1rem solid rgba(0, 0, 0, 0.1);
  background: #ffffff;
  z-index: 3;
`;
const SidebarInner = styled.nav``;

const SignoutUl = styled.ul`
  width: 100%;
  position: absolute;
  bottom: 0;
  border-top: 1px #f5f5f5 solid;
`;

const SignoutLi = styled.li`
  list-style: none;
`;

const HelpLink = styled.a`
  display: block;
  padding: 1.8rem 2.5rem;
  color: #333333;
  text-decoration: none;
  background: #ffffff;
  position: relative;
  transition: all 0.3s ease-out;
  :hover {
    background: #f0f0f0;
  }
  cursor: pointer;
`;

const SignoutLink = styled.a`
  display: block;
  padding: 1.8rem 2.5rem;
  color: #333333;
  text-decoration: none;
  background: #ffffff;
  position: relative;
  transition: all 0.3s ease-out;
  :hover {
    background: #f0f0f0;
  }
  cursor: pointer;
`;

const IconImg = styled.img`
  width: 0.85rem;
  position: absolute;
  right: 2.5rem;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.6;
`;

const SidebarLink = styled.a<{ isActive: boolean }>`
  display: block;
  padding: 1.8rem 2.5rem;
  color: #333333;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease-out;
  :hover {
    background: #f0f0f0;
  }
  svg {
    width: 0.4rem;
    position: absolute;
    right: 2.5rem;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.6;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background: #f5f5f5;
    `}
`;
